import { DisplayData, TenantOrderLine } from '~/lib/model';
import { Big } from 'big.js';
import TwtJob from '~/tenants/twt/model/TwtJob';
import { schema_latest_version, ZodVersionedMetadata } from '~/lib/zod';
import { PersonaType } from '~/tenants/common/TenantPersona';
import TwtVirtualConfig from '~/tenants/twt/performable/virtual/TwtVirtualConfig';
import { DeliverableType } from '~common/model/Deliverable';
import TwtPhotoConfig from '~/tenants/twt/performable/photo/TwtPhotoConfig';
import { TwtOrderType } from '~/tenants/twt/model/enums';
import { Duration } from 'luxon';
import { TenantJobInput } from '~/tenants/common/TenantJob';
import { twt_version, TwtVersion } from '~/tenants/twt/data';

export const TWT_VIRTUAL_PRICE = 45;

export class TwtVirtualJob extends TwtJob<typeof TwtVirtualConfig> {
  get performable() {
    return TwtVirtualConfig;
  }

  get dependencies() {
    return [TwtPhotoConfig.id];
  }

  get input(): TenantJobInput | null {
    // if (twt_version(this.order.created, TwtVersion.V15)) {
    //   return {
    //     performables: [TwtPhotoConfig.id],
    //     required: this.metadata.photos,
    //     description: 'Select which photos to use for virtual twilight',
    //     title: 'Virtual Twilight',
    //   };
    // }

    return null;
  }

  info(): DisplayData[] {
    const info = super.info();

    info.push({
      name: 'Photos',
      value: this.metadata.photos.toString(),
    });

    if (this.metadata.instructions) {
      info.push({
        name: 'Instructions',
        value: this.metadata.instructions,
      });
    }

    return info;
  }

  get deliverable(): DeliverableType {
    return DeliverableType.PHOTO;
  }

  defaultValue(): ZodVersionedMetadata<(typeof TwtVirtualConfig)['schema']> {
    // TODO: type fix?
    return {
      version: schema_latest_version(TwtVirtualConfig.schema),
      photos: 1,
    } as any;
  }

  get eligible() {
    return (
      this.order.metadata.type !== TwtOrderType.COMMERCIAL &&
      !this.order.jobs.some((j) => j.performable_id === 'photo' && j.metadata.twilight)
    );
  }

  get configurable() {
    return true;
  }

  get short() {
    return 'VIRT';
  }

  get media() {
    return PersonaType.OFFICE;
  }

  get completeWithin() {
    return Duration.fromObject({ hours: 24 });
  }

  revenueLines(): TenantOrderLine[] {
    return [
      {
        amount: new Big(twt_version(this.order.created, TwtVersion.V21) ? TWT_VIRTUAL_PRICE : 35).times(this.metadata.photos),
        taxable: true,
        description: `Virtual Twilight (${this.metadata.photos} photos)`,
        id: 'photos',
      },
    ];
  }
}
